














































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";
import { Locales } from "@/i18n/locales";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

@Component
export default class GrantListComponent extends Vue {
  countLoop: number = 0;
  dataLength: number = 0;
  Edit: boolean = true;
  grants: Array<any> = [];
  defaultData: Array<any> = [];
  uploadReady: boolean = true;
  appStatus: any = _app.applicationStatus;

  openStatus = [ _app.grantStatus.monitor, _app.grantStatus.closeInProgress, _app.grantStatus.close ];
  actions = _app.actions;
  subjects = _app.subjects;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  data() {
    var self = this;
    return { grants: self.grants, Edit: self.Edit };
  }

  formatCurrency(val, currency) {
    return utils.formatCurrency(val, currency, this.defaultLocale);
  }

  /** check button access rights */
  accessRights(card, btn) {
    //@ts-ignore
    if(this.$can(this.actions.read, this.subjects.grant) || this.openStatus.includes(card.WorkFlowStatusId))
      return true;
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    var self = this;
    this.$services.grant.listGrants().then((data: any) => {
      if (data.Result === "OK") {
        self.grants = data.Record;
      }
    });
  }

  /** pick random color */
  randomColor() {
    var colourList = [
      "#c0e3e9",
      "#dad8d2",
      "rgb(173, 209, 230)",
      "rgb(173, 209, 230)",
      "#c2cfe4",
      "rgb(190, 208, 218)",
      "#c0e3e9",
      "rgb(209, 232, 245)",
      "#dad8d2",
      "rgb(220, 218, 194)"
    ];
    var cardColor = colourList[Math.floor(Math.random() * colourList.length)];
    return cardColor;
  }

  /** Edit Proposal */
  editGrant(grantId, appId) {
    var self = this;
    this.$router.push({
      name: "grantSummary",
      params: { grantId: grantId, appId: appId }
    });
  }

  /** Delete Proposal*/
  deleteProposal() {}
}
